import React from 'react'

const Footer = () => {
  return (
    <footer >
  <div class=" has-text-centered">
    <p>

       Ceny mogą różnić się od rzeczywistości. 
        <a href="mailto:kontakt@lekeo.pl"> kontakt@lekeo.pl </a>
    </p>
  </div>
</footer>
  )
}

export default Footer